// extracted by mini-css-extract-plugin
export default {"questionSection":"styles__questionSection___bReoQ","titleBlock":"styles__titleBlock___B8Twt","titleLeft":"styles__titleLeft___AAXWr","titleRight":"styles__titleRight___IrSyx"};